import { render, staticRenderFns } from "./HotGoods.vue?vue&type=template&id=3f7b7438&scoped=true&"
import script from "./HotGoods.vue?vue&type=script&lang=js&"
export * from "./HotGoods.vue?vue&type=script&lang=js&"
import style0 from "styles/views/index/hotgoods.css?vue&type=style&index=0&id=3f7b7438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7b7438",
  null
  
)

export default component.exports